import { Info } from "lucide-react";
import RefundNote from "../../../../components/Notes/RefundNote";

const PaymentFooterInfo = () => {
    return (
        <div
            className="root_track"
            style={{ display: "flex", gap: "9px", marginTop: "10px" }}
        >
            <div>
                <Info size={18} />
            </div>

            <div>
                <RefundNote />
            </div>
        </div>
    );
};
export default PaymentFooterInfo;
